import React, { useContext, useEffect, useState } from 'react'
import { Button, Form, Icon, Modal, Divider } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
// import { useTranslation } from 'react-i18next'
// import { history } from '../../../../redux/store'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import Swal from 'sweetalert2'
import StatusDialog from '../../../status-dialog'
import {
  GetCustomerDevicesUpOnType,
  AssignAssetToDevice,
} from '../../../../services/asset/index'
// import { RefreshCustomerAssetList } from '../../../../redux/actions/asset'
import IntelMsg from '../../../ItelMsg'
import { AssetViewContext } from '../../asset-info-view/assetView'
const formValidator = {
  // gatewayTypes: yup.string().required('Required'),
  // GatewaySKU: yup.string().required('Required'),
  // gateway: yup.string().required('Required'),
  // DeviceSKU: yup.string().required('Required'),
  // devices: yup.string().required('Required'),
}
export default function AssignModal() {
  const [gatewayType, setGatewayType] = useState()
  const [gatewaySKUList, setGatewaySKUList] = useState()
  const [gatewayList, setGatewayList] = useState()
  const [sensorList, setSensorList] = useState()
  const [selectedGatewaySku, setSelectedGatewaySku] = useState()
  const [selectedDeviceSku, setSelectedDeviceSku] = useState()
  const [showDialog, setShowDialog] = useState(false)
  const [gatewayName, setGatewayName] = useState()
  const [deviceIds, setDeviceIds] = useState([])
  const { assetData } = useContext(AssetViewContext)
  console.log(deviceIds)
  console.log('assetData', assetData)
  const [disableSubmit] = useState(false)
  const [statusDialogContent] = useState('')
  const { email } = useSelector((store) => ({
    email: store.auth.userEmail,
    productName: store.product.productName,
  }))
  const customer = localStorage.getItem('customer')
  const product = localStorage.getItem('product')
  console.log(email)
  console.log('customer', customer)
  const { assignAssetModal, setAssetAssignModal } = useContext(AssetViewContext)

  //   const { t } = useTranslation()
  //   const specialChar = /^[A-Za-z0-9ء-ي ]+$/

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })
  const gatewayOptions = [
    { key: 'm6', text: 'Standard+ Gateway', value: 'Standard+ Gateway' },
    { key: 'f6', text: 'Standard Gateway', value: 'Standard Gateway' },
    { key: 'o6', text: 'Fixed Gateway', value: 'Fixed Gateway' },
    { key: 's9', text: 'Moving Gateway', value: 'Moving Gateway' },
  ]
  const StandardPlusGateway = [
    { key: 'm5', text: 'SPGW001', value: 'SPGW001' },
    { key: 'f5', text: 'SPGW011', value: 'SPGW011' },
    { key: 'o5', text: 'SPGW002', value: 'SPGW002' },
    { key: 's8', text: 'SPGW012', value: 'SPGW012' },
  ]
  const StandardGateway = [
    { key: 'm4', text: 'SPGW101', value: 'SPGW101' },
    { key: 'f4', text: 'SPGW111', value: 'SPGW111' },
    { key: 'o4', text: 'SPGW102', value: 'SPGW102' },
    { key: 's7', text: 'SPGW112', value: 'SPGW112' },
  ]
  const FixedGateway = [
    { key: 'm3', text: 'SPGW200', value: 'SPGW200' },
    { key: 'f3', text: 'SPGW201', value: 'SPGW201' },
    { key: 'o3', text: 'SPGW202', value: 'SPGW202' },
  ]
  const MovingGateway = [
    { key: 'm2', text: 'SPGW301', value: 'SPGW301' },
    { key: 'f2', text: 'SPGW311', value: 'SPGW311' },
    { key: 'o2', text: 'SPGW302', value: 'SPGW302' },
    { key: 's6', text: 'SPGW312', value: 'SPGW312' },
  ]
  const SensorNodes = [
    { key: 'm1', text: 'SCTHL-01', value: 'SCTHL-01' },
    { key: 'f1', text: 'SCTH-01', value: 'SCTH-01' },
    { key: 'o1', text: 'SCTHD-01', value: 'SCTHD-01' },
    { key: 's5', text: 'SCDS-01', value: 'SCDS-01' },
    { key: 's4', text: 'SCTHB-01', value: 'SCTHB-01' },
    { key: 's3', text: 'SCDB-01', value: 'SCDB-01' },
    { key: 's2', text: 'SCCH-01', value: 'SCCH-01' },
    { key: 's1', text: 'SCRF-01', value: 'SCRF-01' },
  ]
  useEffect(() => {
    if (gatewayType) {
      if (gatewayType === 'Standard+ Gateway') {
        setGatewaySKUList(StandardPlusGateway)
      }
      if (gatewayType === 'Standard Gateway') {
        setGatewaySKUList(StandardGateway)
      }
      if (gatewayType === 'Fixed Gateway') {
        setGatewaySKUList(FixedGateway)
      }
      if (gatewayType === 'Moving Gateway') {
        setGatewaySKUList(MovingGateway)
      }
    }
  }, [gatewayType])
  const gateways = []
  useEffect(() => {
    if (selectedGatewaySku) {
      GetCustomerDevicesUpOnType(
        product,
        'gateway',
        customer,
        selectedGatewaySku,
      ).then((gats) => {
        gats.forEach((element) => {
          gateways.push({
            text: element['device name'],
            value: element['device id'],
          })
        })
        setGatewayList(gateways)
      })
    }
  }, [selectedGatewaySku])
  const sensors = []
  useEffect(() => {
    if (selectedDeviceSku) {
      GetCustomerDevicesUpOnType(
        product,
        'sensor',
        customer,
        selectedDeviceSku,
      ).then((sens) => {
        sens.forEach((element) => {
          sensors.push({
            text: element['device name'],
            value: element['device id'],
          })
        })
        setSensorList(sensors)
      })
    }
  }, [selectedDeviceSku])

  const onSubmit = () => {
    console.log('devices', deviceIds)
    if (!gatewayType && !selectedDeviceSku) {
      Swal.fire({
        title: 'Please select gateway or device',
        icon: 'error',
        confirmButtonColor: 'Red',
      })
    } else if (gatewayType) {
      if (!selectedGatewaySku) {
        Swal.fire({
          title: 'Please select gateway SKU',
          icon: 'error',
          confirmButtonColor: 'Red',
        })
      } else if (!gatewayName) {
        Swal.fire({
          title: 'Please select a gateway',
          icon: 'error',
          confirmButtonColor: 'Red',
        })
      } else {
        const bodyData = []
        if (deviceIds.length > 0) {
          deviceIds.forEach((e) => {
            bodyData.push({ id: e })
          })
        }

        bodyData.push({ id: gatewayName, type: gatewayType })
        console.log('bodyData', bodyData)

        try {
          AssignAssetToDevice(
            assetData['asset id'],
            assetData['asset type'],
            product,
            customer,
            bodyData,
          ).then(async (response) => {
            if (response.success) {
              await Swal.fire({
                title: 'Assigned Successfully',
                icon: 'success',
                confirmButtonColor: 'Green',
              })
            } else {
              Swal.fire({
                title:
                  'Sorry please make sure that this asset assigned to hierarchy!',
                icon: 'error',
                confirmButtonColor: 'Red',
              })
            }
          })
        } catch (e) {
          Swal.fire({
            title: 'Sorry we are not able to complete your request right now!',
            icon: 'error',
            confirmButtonColor: 'Red',
          })
        }
      }
    } else if (selectedDeviceSku) {
      if (deviceIds.length === 0) {
        Swal.fire({
          title: 'Please Select Devices',
          icon: 'error',
          confirmButtonColor: 'Red',
        })
      } else {
        const bodyData = []
        deviceIds.forEach((e) => {
          bodyData.push({ id: e })
        })
        if (gatewayName) {
          bodyData.push({ id: gatewayName })
        }

        console.log('bodyData', bodyData)

        try {
          AssignAssetToDevice(
            assetData['asset id'],
            assetData['asset type'],
            product,
            customer,
            bodyData,
          ).then((response) => {
            if (response.success) {
              Swal.fire({
                title: 'Assigned Successfully',
                icon: 'success',
                confirmButtonColor: 'Green',
              })
            } else {
              Swal.fire({
                title:
                  'Sorry please make sure that this asset assigned to hierarchy!',
                icon: 'error',
                confirmButtonColor: 'Red',
              })
            }
          })
        } catch (e) {
          Swal.fire({
            title: 'Sorry we are not able to complete your request right now!',
            icon: 'error',
            confirmButtonColor: 'Red',
          })
        }
      }
    }
  }
  return (
    <>
      <Modal
        onClose={() => setAssetAssignModal(false)}
        onOpen={() => setAssetAssignModal(true)}
        open={assignAssetModal}
        size="small"
        style={{ position: 'relative', height: 'auto' }}
      >
        <Modal.Header style={{ background: '#1678c2', color: 'white' }}>
          <IntelMsg id="assignAssetToDevices" />
        </Modal.Header>
        <Modal.Content scrolling>
          <Form id="assign" onSubmit={handleSubmit(onSubmit)} widths="equal">
            <Form.Group widths="equal">
              <div style={{ width: '100%' }}>
                <Form.Select
                  name="gatewayTypes"
                  ref={register}
                  fluid
                  label="Gateway Type"
                  options={gatewayOptions}
                  placeholder="Gateway Type"
                  onChange={(e, data) => {
                    setGatewayType(data.value)
                  }}
                />

                {errors.gatewayTypes && (
                  <small style={{ color: 'red' }}>
                    {errors.gatewayTypes.message}
                  </small>
                )}
              </div>
              <div style={{ width: '100%', marginLeft: '2px' }}>
                <Form.Select
                  name="GatewaySKU"
                  ref={register}
                  fluid
                  label="Gateway SKU"
                  options={gatewaySKUList}
                  placeholder="Gateway SKU"
                  onChange={(e, data) => {
                    setSelectedGatewaySku(data.value)
                  }}
                />

                {errors.GatewaySKU && (
                  <small style={{ color: 'red' }}>
                    {errors.GatewaySKU.message}
                  </small>
                )}
              </div>
              <div style={{ width: '100%', marginLeft: '2px' }}>
                <Form.Select
                  name="gateway"
                  ref={register}
                  fluid
                  label="Gateway"
                  options={gatewayList}
                  onChange={(e, data) => {
                    setGatewayName(data.value)
                  }}
                  placeholder="Gateway List"
                />

                {errors.gateway && (
                  <small style={{ color: 'red' }}>
                    {errors.gateway.message}
                  </small>
                )}
              </div>
            </Form.Group>
            <Divider horizontal>-----</Divider>
            <Form.Group>
              <div style={{ width: '100%' }}>
                <Form.Select
                  name="DeviceSKU"
                  ref={register}
                  fluid
                  label="Sensor SKU"
                  options={SensorNodes}
                  placeholder="Device SKU List"
                  onChange={(e, data) => {
                    console.log(data)
                    setSelectedDeviceSku(data.value)
                  }}
                />

                {errors.DeviceSKU && (
                  <small style={{ color: 'red' }}>
                    {errors.DeviceSKU.message}
                  </small>
                )}
              </div>
              <div style={{ width: '100%', marginLeft: '2px' }}>
                <Form.Select
                  name="devices"
                  ref={register}
                  fluid
                  multiple
                  label="Sensors"
                  options={sensorList}
                  onChange={(e, data) => {
                    setDeviceIds(data.value)
                  }}
                  placeholder="Devices List"
                />

                {errors.devices && (
                  <p style={{ color: 'red' }}>{errors.devices.message}</p>
                )}
              </div>
            </Form.Group>
            <Button
              type="submit"
              from="assign"
              color="blue"
              disabled={disableSubmit}
            >
              <IntelMsg id="submit" />
            </Button>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            onClick={() => {
              setAssetAssignModal(false)
              window.location.reload(true)
            }}
          >
            <IntelMsg id="Close" />
          </Button>
        </Modal.Actions>
      </Modal>
      <StatusDialog
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        dialogHeader="Device Configuration Issue"
        dialogContent={
          <>
            <Icon name="exclamation triangle" size="huge" color="red" />
            <p style={{ fontSize: 'x-large' }}>{statusDialogContent}</p>
          </>
        }
      />
    </>
  )
}
